import React, { useContext, useEffect, useRef } from 'react';
import { navigate } from 'gatsby';
import { useIntl } from 'react-intl';

import { UIContext } from 'context/ui';
import { useKeyDown } from 'hooks/use-keydown';
import { getLang } from 'utils/getLangPath';

import { Container } from 'components/container/Container';

import s from './SearchInput.scss';

interface IProps {
  children?: React.ReactNode;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
  isOverlay?: boolean;
}

export const SearchInput = ({ placeholder, onChange, value, isOverlay = true }: IProps) => {
  const { toggleSearch } = useContext<any>(UIContext);
  const keys = useKeyDown();
  const inputRef = useRef<HTMLInputElement>(null);
  const intl = useIntl();
  const { locale } = intl;

  const onEnter = () => {
    if (isOverlay) {
      const query = inputRef.current?.value;
      navigate(`${getLang(locale)}/leit/?query=${query}`);

      setTimeout(() => {
        toggleSearch(false);
      }, 500);
    }
  };

  useEffect(() => {
    if (!isOverlay) {
      return;
    }
    if (keys.includes('Enter')) {
      onEnter();
    }
  }, [keys]);

  return (
    <Container>
      <div className={s('searchInput', { isOverlay })}>
        <div className={s.searchInput__container}>
          <label htmlFor="search-input">
            <span className={s.searchInput__label}>
              {intl.formatMessage({ id: 'search.label' })}
            </span>
            <span className={s.searchInput__inputWrap}>
              <input
                className={s.searchInput__input}
                id="search-input"
                type="search"
                placeholder={
                  placeholder ??
                  intl.formatMessage({ id: 'search.placeholder', defaultMessage: 'Leitarorð' })
                }
                value={value}
                onChange={onChange}
                ref={inputRef}
              />
            </span>
          </label>

          {/* <button onClick={onEnter}>temp search button</button> */}
        </div>
      </div>
    </Container>
  );
};
